import type { JSX } from "react";
import type { ValidationResult, Validator } from "@entrilia/shared/utilities/validators";
import type {
  EntityFieldConfiguration,
  FieldAttribute,
  TextEntityFieldConfiguration,
} from "../../../api/types/objectTypes";
import TextValueEdit from "./TextValueEdit";

interface Props {
  value: string;
  fieldId: string;
  fieldConfiguration: EntityFieldConfiguration | undefined;
  fieldAttributes: FieldAttribute[];
  onChange: (value: string, fieldId: string, validationResult: ValidationResult) => void;
  validator?: Validator<string>;
  transformOnChangeFunc?: (value: string) => string;
  defaultHelperText?: string;
  displayValueComponent?: JSX.Element | JSX.Element[] | null;
  displayHoverComponent?: JSX.Element | JSX.Element[] | null;
  multiline?: boolean;
  fieldInputId?: string;
  editViaDialog?: boolean;
  onEditDialogOpen?: () => void;
  readonlyReason?: string;
}

const EntityTextFieldComponent = (props: Props) => {
  const { value, fieldId, fieldConfiguration, fieldAttributes, onChange } = props;

  return (
    <TextValueEdit
      {...props}
      value={value}
      maxLength={(fieldConfiguration as TextEntityFieldConfiguration | undefined)?.maxLength}
      onChange={(value, validationResult) => onChange(value, fieldId, validationResult)}
      fieldAttributes={fieldAttributes}
    />
  );
};

export default EntityTextFieldComponent;
